// extracted by mini-css-extract-plugin
module.exports = {"loginButton":"facebookLogin_loginButton__2Qp0A"};